var Cookies = {
    GetCookie : function( cname ){
        var name = cname + '=';
        var decodedCookie = decodeURIComponent( document.cookie );
        var ca = decodedCookie.split(';' );

        for( var i = 0; i < ca.length; i++ ) {
            var c = ca[i];
            while ( c.charAt(0) === ' ' ) {
                c = c.substring(1);
            }
            if ( c.indexOf(name) === 0 ) {
                return c.substring( name.length, c.length );
            }
        }

        return false;
    },

    SetCookie : function( name, value, path, expires, domain ){
        document.cookie = name + '=' + encodeURIComponent(value) + (path ? "; path=" + path : '') + (expires ? "; expires=" + expires : '') + (domain ? "; domain=" + domain : '');
    }
};

var QueryVars = {
    GetQueryVar : function (variable) {
        var query = window.location.search.substring(1);
        var vars = query.split('&');
        var result = false;

        for( var i = 0; i < vars.length; i++ ) {
            var pair = vars[i].split('=');
            if ( decodeURIComponent( pair[0] ) === variable ) {
                result = decodeURIComponent( pair[1] );
                break;
            }
        }

        return result;
    }
};